import { useState, useEffect } from "react";
import axios from "axios";
import Spinner from "../../ui/spinner/Spinner";
import styles from "./Selections.module.css";

const Selections = (props) => {
  const [showSpinner, setShowSpinner] = useState(false);
  const [grade, setGrade] = useState(false);
  const [getPapers, setGetPapers] = useState(false);
  const [showTestLevel, setShowTestLevel] = useState(false);
  //const [oLevelSubjects, setOLevelSubjects] = useState([]);
  const [listOfTestPapers, setListOfTestPapers] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedTestPaper, setSelectedTestPaper] = useState("");
  const [selectedTestLevel, setSelectedTestLevel] = useState("");

  const oLevelSubjects = [
    "Accounting",
    "Agricultural Science",
    "Biology",
    "Chemistry",
    "Commerce",
    "Economics",
    "English Language",
    "Food and Nutrition",
    "Further Mathematics",
    "Geography",
    "Literature in English",
    "Mathematics",
    "Physics",
  ];

  const aLevelSubjects = [
    "Biology",
    "Chemistry",
    "Computer Science",
    "Economics",
    "English Language",
    "English Literature",
    "Further Mathematics",
    "Geography",
    "Mathematics",
    "Physics",
  ];
  /* List of o-Level subjects above. Server subjects table no longer required
  const fetchSubjects = async () => {
    try {
      setShowSpinner(true);

      const response = await axios.post(
        "php/study_room/get_subjects.php",
        {},
        {
          headers: { "Content-Type": "application/json" },
        },
      );

      console.log("RAW RESPONSE", response);
      console.log("DATA", response.data);

      const data = response.data;

      if (data.code !== 200) {
        alert("Error getting list of subjects. Check your internet and retry");
        return;
      }

      setOLevelSubjects(Array.isArray(data.subjects) ? data.subjects : []);

    } catch (error) {
      alert(`An error occurred. Please try again. ${error}`);
      return;

    } finally {
      setShowSpinner(false);
    }
  };

  useEffect(() => {
    fetchSubjects();
  }, []);
  */

  const loadSelectedSubjectHandler = async () => {
    if (!grade || !selectedSubject || !selectedType) {
      alert("Select grade, subject and type");
      return;
    }

    try {
      setShowSpinner(true);
      setGetPapers(false);
      setShowTestLevel(false);
      setSelectedTestPaper("");
      setSelectedTestLevel("");
      setListOfTestPapers([]);

      const searchData = {
        grade,
        subject: selectedSubject,
        type: selectedType,
      };

      console.log("SEARCH DATA", searchData);

      const response = await axios.post(
        "php/study_room/get_selected_subject_test_list.php",
        searchData,
        {
          headers: { "Content-Type": "application/json" },
        },
      );

      //console.log("RAW RESPONSE", response);
      console.log("DATA", response.data);

      const data = response.data;

      if (data.code === 400 || data.code === 404 || data.code === 504) {
        alert(
          `Sorry, there is no test paper for ${selectedSubject} ${selectedType}`,
        );
        return;
      }

      if (data.code !== 200) {
        alert(
          "Could not get test papers. Please check your internet connection.",
        );
        return;
      }

      setListOfTestPapers(
        Array.isArray(data.test_papers) ? data.test_papers : [],
      );
      setGetPapers(true);
    } catch (error) {
      alert(
        `Sorry, right now, there is no test paper for ${selectedSubject} ${selectedType}`,
      );
      return;
    } finally {
      setShowSpinner(false);
    }
  };

  const loadSelectedTestPaperHandler = () => {
    if (!selectedTestPaper) {
      alert("Select test paper");
      return;
    }

    if (selectedType !== "Objective") {
      props.onShowTestPaper(
        grade,
        selectedSubject,
        selectedType,
        listOfTestPapers,
        selectedTestPaper,
        selectedTestLevel,
      );
      return;
    }

    setShowTestLevel(true);
  };

  const submitTestLevelHandler = () => {
    if (!selectedTestLevel) {
      alert("Select test level");
      return;
    }

    props.onShowTestPaper(
      grade,
      selectedSubject,
      selectedType,
      listOfTestPapers,
      selectedTestPaper,
      selectedTestLevel,
    );
  };

  return (
    <>
      <div className={styles.classes}>
        <div className={styles.floatRight}>
          <button
            className={styles.bgRed}
            onClick={props.onCancel}
            type="button"
          >
            Cancel
          </button>
        </div>

        <header className={styles.hdrMT}>
          <h2>Search for test paper</h2>
        </header>

        <p>Select grade, subject, type and test paper</p>
      </div>

      <div className={styles.classes}>
        {!showSpinner && (
          <div>
            <label htmlFor="grade">Select grade*:</label>
            <select
              id="grade"
              value={grade}
              onChange={(e) => setGrade(e.target.value)}
            >
              <option value=""></option>
              <option value="oLevel">Ordinary Level</option>
              <option value="aLevel">Advance Level</option>
            </select>
          </div>
        )}

        {/*grade == "oLevel" && oLevelSubjects.length === 0 && !showSpinner && (
          <div>
            <p style={{ textAlign: "center" }}>No subjects found</p>
          </div>
        )*/}

        <>
          {grade == "oLevel" && (
            <div>
              <label htmlFor="subjects">Select O-Level subject*:</label>
              <select
                id="subjects"
                value={selectedSubject}
                onChange={(e) => setSelectedSubject(e.target.value)}
              >
                <option value=""></option>
                {oLevelSubjects.map((subject) => (
                  <option key={subject} value={subject}>
                    {subject}
                  </option>
                ))}
              </select>
            </div>
          )}

          {grade == "aLevel" && (
            <div>
              <label htmlFor="subjects">Select A-Level subject*:</label>
              <select
                id="subjects"
                value={selectedSubject}
                onChange={(e) => setSelectedSubject(e.target.value)}
              >
                <option value=""></option>
                {aLevelSubjects.map((subject) => (
                  <option key={subject} value={subject}>
                    {subject}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div>
            <label htmlFor="subjectType">Select type*:</label>
            <select
              id="subjectType"
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
            >
              <option value=""></option>
              <option value="Objective">Objective</option>
              <option value="Theory">Theory</option>
            </select>
          </div>

          <button
            className={`${styles.bgBlue} ${styles.btnTBMargins}`}
            type="button"
            onClick={loadSelectedSubjectHandler}
          >
            Submit
          </button>
        </>
      </div>

      {getPapers && (
        <div className={styles.classes}>
          {listOfTestPapers.length === 0 && (
            <div>
              <p style={{ textAlign: "center" }}>No test paper found</p>
            </div>
          )}

          {listOfTestPapers.length > 0 && (
            <>
              <div>
                <label htmlFor="test_papers_list">Select test paper*:</label>
                <select
                  id="test_papers_list"
                  value={selectedTestPaper}
                  onChange={(e) => setSelectedTestPaper(e.target.value)}
                >
                  <option value=""></option>
                  {listOfTestPapers.map((paper) => (
                    <option key={paper} value={paper}>
                      {paper}
                    </option>
                  ))}
                </select>
              </div>

              <button
                className={`${styles.bgBlue} ${styles.btnTBMargins}`}
                type="button"
                onClick={loadSelectedTestPaperHandler}
              >
                Submit
              </button>
            </>
          )}
        </div>
      )}

      {showTestLevel && selectedType === "Objective" && (
        <div className={styles.classes}>
          <label htmlFor="test_level">Select test level*:</label>
          <select
            id="test_level"
            value={selectedTestLevel}
            onChange={(e) => setSelectedTestLevel(e.target.value)}
          >
            <option value=""></option>
            <option value="3">Allow 3 attempts per question</option>
            <option value="2">Allow 2 attempts per question</option>
            <option value="1">Allow 1 attempt per question</option>
          </select>

          <button
            className={`${styles.bgBlue} ${styles.btnTBMargins}`}
            type="button"
            onClick={submitTestLevelHandler}
          >
            Submit
          </button>
        </div>
      )}

      {showSpinner && <Spinner />}
    </>
  );
};

export default Selections;

/*
import { useState, useEffect } from "react";
import Spinner from "../../ui/spinner/Spinner";
import styles from "./Selections.module.css";
import axios from 'axios';

const Selections = (props) => {
  const [showSpinner, setShowSpinner] = useState();
  const [getPapers, setGetPapers] = useState();
  const [showTestLevel, setShowTestLevel] = useState();
  const [listOfSubjects, setListOfSubjects] = useState();

  const fetchSubjects = async () => {
    try {
      setShowSpinner(true);
      const response = await axios.post("php/study_room/get_subjects.php", {}, {
        headers: { "Content-Type": "application/json" },
      });

      console.log("RAW RESPONSE", response);
      console.log("DATA", response.data);

      const data = response.data;
      const code = data.code;

      if (code !== 200) {
        if (code === 1) {
          setShowSpinner(false);
          alert("Error getting list of subjects. Retry");
          return;
        }

        setShowSpinner(false);
        alert(
          "Error connecting to server. Check your internet connection or retry",
        );
        return;
      }

      setShowSpinner(false);
      setListOfSubjects(data.subjects);

    } catch (error) {
      setShowSpinner(false);
      alert(`An error ${error} has occurred. Please try again`);
    };
  }

  useEffect(() => {
    fetchSubjects();
  }, []);

  const [selectedSubject, setSelectedSubject] = useState();
  const [selectedType, setSelectedType] = useState();
  const [listOfTestPapers, setListOfTestPapers] = useState([]);
  const [selectedTestLevel, setSelectedTestLevel] = useState("");
  const [selectedTestPaper, setSelectedTestPaper] = useState()
  
  const loadSelectedSubjectHandlder = async () => {
    const obj = document.getElementById("subjects");
    let subject = obj.options[obj.selectedIndex].value;
    setSelectedSubject(subject);
    const element = document.getElementById("subjectType");
    let type = element.options[element.selectedIndex].value;
    setSelectedType(type)
    console.log("subject type: ", subject, type);
    if (!subject || !type) {
      alert("Select subject and type");
      return;
    }
    const search_data = {
      subject: subject,
      type: type,
    };
    try {
      setShowSpinner(true);
      const response = await axios.post(
        "php/study_room/get_selected_subject_test_list.php",
        search_data,
        { headers: { "Content-Type": "application/json" } },
      );
      
      console.log("RAW RESPONSE", response);
      console.log("DATA", response.data);
      const data = response.data;
      const code = data.code;

      if (code == 400 || code == 404 || code == 504) {
        setShowSpinner(false);
        alert(
          `Sorry, there is no test paper for ${subject} ${type}`
        );
        return;
      }
      
      if (code !== 200) {
        setShowSpinner(false);
        alert(
          "Your performance record could not be updated. Please check your internet connection",
        );
        return;
      } 
      
      setShowSpinner(false);
      setGetPapers(true);
      setListOfTestPapers(data.test_papers);
      
    } catch (error) {
      setShowSpinner(false);
      alert(`Sorry, right now, there is no test paper for ${subject} ${type}`);

    } finally {
      setShowSpinner(false);
    }
  };

  const loadSelectedTestPaperHandlder = () => {
    const obj = document.getElementById("test_papers_list");
    const selectedPaper = obj.options[obj.selectedIndex].value;
    setSelectedTestPaper(selectedPaper)
    console.log("selectedPaper: ", selectedPaper);
    if (!selectedPaper) {
        alert('Select test paper');
        return;
    }
    if (selectedType !== "Objective")
      props.onShowTestPaper(selectedSubject, selectedType, listOfTestPapers, selectedPaper, selectedTestLevel);
    else {
      setShowTestLevel(true);
    }    
  };

  const submitTestLevelHandlder = () => {
    const obj = document.getElementById("test_level");
    let selectedLevel = obj.options[obj.selectedIndex].value;
    setSelectedTestLevel(selectedLevel);
  };

  useEffect(() => {
    if (selectedTestLevel) {
      props.onShowTestPaper(selectedSubject, selectedType, listOfTestPapers, selectedTestPaper, selectedTestLevel);
    }
  }, [selectedTestLevel]);

  return (
    <>
      <div className={styles.classes}>
        <div className={styles.floatRight}>
          <button className={styles.bgRed} onClick={props.onCancel}>
            Cancel
          </button>
        </div>
        <header className={styles.hdrMT}>
          <h2>Search for test paper</h2>
        </header>
        <p>Select subject, type and test paper</p>
      </div>
      <div className={styles.classes}>
        {listOfSubjects && (
          <>
            <div>
              <label htmlFor="subjects">Select subject*:</label>
              <select id="subjects">
                <option></option>
                {listOfSubjects.map((subject) => (
                  <option key={subject} value={subject}>
                    {subject}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label htmlFor="subjectType">Select type*:</label>
              <select id="subjectType">
                <option></option>
                <option>Objective</option>
                <option>Theory</option>
              </select>
            </div>
            <button
              className={`${styles.bgBlue} ${styles.btnTBMargins}`}
              type="button"
              onClick={loadSelectedSubjectHandlder}
            >
              Submit
            </button>
          </>
        )}
      </div>
      {getPapers && (
        <div className={styles.classes}>        
          <div>
            <label htmlFor="test_papers_list">Select test paper*:</label>
            <select id="test_papers_list">
              <option></option>
              {listOfTestPapers.map((paper) => (
                <option key={paper} value={paper}>
                  {paper}
                </option>
              ))}
            </select>
          </div>
          <button
            className={`${styles.bgBlue} ${styles.btnTBMargins}`}
            type="button"
            onClick={loadSelectedTestPaperHandlder}
          >
            Submit
          </button>          
        </div>
      )}
      {showTestLevel && selectedType === "Objective" && (
        <div className={styles.classes}>
          <label htmlFor="test_level">Select test level*:</label>
          <select id="test_level">
            <option value=""></option>
            <option value="3">Allow 3 attempts per question</option>
            <option value="2">Allow 2 attempts per question</option>
            <option value="1">Allow 1 attempt per question</option>
          </select>
          <button
            className={`${styles.bgBlue} ${styles.btnTBMargins}`}
            type="button"
            onClick={submitTestLevelHandlder}
          >
            Submit
          </button>
        </div>
      )}
      {showSpinner && <Spinner />}
    </>
  );
};

export default Selections;
*/
